<!-- Button.vue -->

<template>
  <v-btn dark :class="buttonClass" @click="handleClick">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "default", // Pode ser 'default', 'primary', 'secondary', etc.
    },
  },
  computed: {
    buttonClass() {
      return `button-${this.type}`;
    },
  },
  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped>
.button-default {
  background-color: var(--color-surface-muted) !important;
  color: var(--color-text) !important;
}

.button-primary {
  background-color: var(--color-primary) !important;
  color: #fff !important;
}

.button-secondary {
  background-color: var(--color-sidebar-soft) !important;
  color: #fff !important;
}

.button-approve {
  background-color: var(--color-success);
  color: #fff !important;
}

.button-repprove {
  background-color: var(--color-error);
  color: #fff !important;
}
</style>
